import { isPending } from "App/apiMiddleware";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import startsWith from "lodash/startsWith";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getData = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].data`), (data) => data);
export const getChanges = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].draft`), (draft) => draft);
export const getHasChanges = createSelector((state) => getChanges(state), (draft) => !isEmpty(draft));
export const getDocumentId = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].documentId`), (documentId) => documentId);
export const getMode = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].mode`), (mode) => mode);
export const getDraft = createSelector((state) => getData(state), (state) => getChanges(state), (state) => getDocumentId(state), (data, draft, documentId) => {
    if (isNil(documentId) || !data)
        return undefined;
    return {
        ...data,
        ...(draft || {})
    };
});
export const getInProgress = (state) => isPending(state, e => startsWith(e, actionTypes.PREVIEW_IMPORT)) ||
    isPending(state, `${actionTypes.SAVE_DOCUMENT}_${getDocumentId(state)}`) ||
    isPending(state, `${actionTypes.GET_DOCUMENT}_${getDocumentId(state)}`) ||
    isPending(state, `${actionTypes.GET_WORKSPACE_PROJECTS}_${getDocumentId(state)}`) ||
    isPending(state, `${actionTypes.DUPLICATE_DOCUMENT}_${getDocumentId(state)}`);
